import React from "react";
import { Helmet } from "react-helmet"



function lastSlashRemover(site) {
  return site.replace(/\/$/, "");
}

export const mainData = () => {
  return {
    htmlLang: "en-US",
    charset: "UTF-8",
    title: "Microvision Infotech | Web & Mobile App Development Company in Indore",
    titleTemplate: "microvisioninfotech.com",
    description: "Microvision Infotech offers custom web development, mobile app development, AI solutions, CRM/ERP systems, and professional IT training services.",
    keywords: "custom web development company, full-stack development services, React and Node.js developers, iOS and Android app development, hybrid mobile app development, Flutter app agency, AI agent development, generative AI integration, custom AI chatbots, online IT training courses, software development classes, web development training in Indore, web development company, mobile app development, custom software solutions, AI development, CRM development, Odoo ERP customization, React JS development, IT training in Indore",
    author: "Ayaz Ahmed Khan",
    viewport: "width=device-width, initial-scale=1.0",
  };
};


export const ogData = () => {

  const siteMainData = mainData();

  const ogURL = "https://microvisioninfotech.com";
  const ogImage = "https://www.microvisioninfotech.com/img/mvit-logo.jpg";
  const ogImageWidth = "672";
  const ogImageHeight = "672";
  const ogImageType = "image/jpg";

  const ogData = {
    ogLocal: "en_US",
    ogType: "website",
    ogTitle: siteMainData.title,
    ogDescription: siteMainData.description,
    ogURL: lastSlashRemover(ogURL),
    ogSiteName: siteMainData.title,
    ogImage: ogImage,
    ogImageWidth: ogImageWidth,
    ogImageHeight: ogImageHeight,
    ogImageType: ogImageType
  };
  return ogData;
};

export const twitterData = () => {

  const siteMainData = mainData();
  const twitterCard = "summary_large_image";
  const twitterUsername = "Nilesh";
  const twitterImage = "https://microvisioninfotech.com/image/resai.png";
  const twitterData = {
    twitterCard: twitterCard,
    twitterUsername: twitterUsername,
    twitterTitle: siteMainData.title,
    twitterDescription: siteMainData.description,
    twitterImage: twitterImage,
  };
  return twitterData;
};

export const Seo = () => {
  const {
    htmlLang,
    charset,
    title,
    description,
    keywords,
    titleTemplate,
    author,
    viewport,
  } = mainData();

  const {
    ogLocal,
    ogType,
    ogTitle,
    ogDescription,
    ogURL,
    ogSiteName,
    ogImage,
    ogImageWidth,
    ogImageHeight,
    ogImageType,
  } = ogData();

  const { twitterCard, twitterUsername, twitterTitle, twitterDescription, twitterImage } =
    twitterData();

  var links = [];
  var meta = [];
  links.push({ rel: "canonical", href: decodeURIComponent(ogURL) });
  links.push({
    rel: "alternate",
    hreflang: "en",
    href: decodeURIComponent(ogURL),
  });
  links.push({ rel: "icon", href: decodeURIComponent("/favicon-logo2x.png") });


  return (
    <Helmet
      htmlAttributes={{
        lang: htmlLang,
      }}
      title={title}
      titleTemplate={titleTemplate}
      link={links}
      meta={[
        {
          name: `charset`,
          content: charset,
        },
        {
          name: `title`,
          content: title,
        },
        {
          name: `description`,
          content: description,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          name: `author`,
          content: author,
        },
        {
          name: `viewport`,
          content: viewport,
        },
        // {
        //   property: `og:local`,
        //   content: ogLocal,
        // },
        // {
        //   property: `og:type`,
        //   content: ogType,
        // },
        // {
        //   property: `og:title`,
        //   content: ogTitle,
        // },
        // {
        //   property: `og:description`,
        //   content: ogDescription,
        // },
        // {
        //   property: `og:url`,
        //   content: ogURL,
        // },
        // {
        //   property: `og:site_name`,
        //   content: ogSiteName,
        // },
        // {
        //   property: `og:image`,
        //   content: ogImage,
        // },
        // {
        //   property: `og:image:width`,
        //   content: ogImageWidth,
        // },
        // {
        //   property: `og:image:height`,
        //   content: ogImageHeight,
        // },
        // {
        //   property: `og:image:type`,
        //   content: ogImageType,
        // },
        // {
        //   name: `twitter:card`,
        //   content: twitterCard,
        // },
        // {
        //   name: `twitter:creator`,
        //   content: twitterUsername,
        // },
        // {
        //   name: `twitter:title`,
        //   content: twitterTitle,
        // },
        // {
        //   name: `twitter:description`,
        //   content: twitterDescription,
        // },
        // {
        //   name: `twitter:image`,
        //   content: twitterImage,
        // },
        {
          "http-equiv": `Cache-Control`,
          content: "no-cache, no-store, must-revalidate",
        },
        {
          "http-equiv": `Pragma`,
          content: "no-cache",
        },
        {
          "http-equiv": `Expires`,
          content: "0",
        },
      ].concat(meta)}
    />
  );
}